// extracted by mini-css-extract-plugin
export default {"paymentSection":"j--z"};